// extracted by css-extract-rspack-plugin
export default {"row":"src-modules-desktop-modules-widgets-components-OnboardingWidget-components-DiscoverAppsModal-components-CardsRow-CardsRow-module__row-ccp94U","centerContent":"src-modules-desktop-modules-widgets-components-OnboardingWidget-components-DiscoverAppsModal-components-CardsRow-CardsRow-module__centerContent-ITKg0p","placeholderCard":"src-modules-desktop-modules-widgets-components-OnboardingWidget-components-DiscoverAppsModal-components-CardsRow-CardsRow-module__placeholderCard-RLYKD1"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"row\":\"src-modules-desktop-modules-widgets-components-OnboardingWidget-components-DiscoverAppsModal-components-CardsRow-CardsRow-module__row-ccp94U\",\"centerContent\":\"src-modules-desktop-modules-widgets-components-OnboardingWidget-components-DiscoverAppsModal-components-CardsRow-CardsRow-module__centerContent-ITKg0p\",\"placeholderCard\":\"src-modules-desktop-modules-widgets-components-OnboardingWidget-components-DiscoverAppsModal-components-CardsRow-CardsRow-module__placeholderCard-RLYKD1\"}";
        // 1793874325029
        var cssReload = require("../../../../../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  